<template>
  <div
    class="modal"
    id="FlowTemplateEditor"
    role="dialog"
    aria-hidden="true"
    data-backdrop="static"
    style="display: none"
  >
    <div class="modal-dialog" style="width: 440px">
      <div class="modal-content">
        <!--Modal header-->
        <div class="modal-header">
          <h4 class="modal-title">
            {{ model == null ? '新建流程模板' : '编辑流程模板' }}
          </h4>
        </div>
        <!--Modal body-->
        <div class="modal-body" style="padding-top: 0">
          <form
            class="form-padding base-form"
            @submit.prevent="postFlowTemplate"
          >
            <div class="form-group">
              <label for class="control-label">
                流程名称
                <small class="help-inline">最大长度为40字</small>
              </label>
              <div class>
                <input
                  type="text"
                  id="demo-text-input"
                  class="form-control"
                  v-model="flowTemplate.name"
                  placeholder="输入流程名称"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="control-label" for="demo-textarea-input"
                >流程说明</label
              >
              <div class>
                <textarea
                  id="demo-textarea-input"
                  rows="9"
                  class="form-control"
                  placeholder
                  v-model="flowTemplate.desc"
                ></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-default"
                data-dismiss="modal"
                type="button"
              >
                取消
              </button>
              <button class="btn btn-primary" type="submit">提交</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { required } from 'vuelidate/lib/validators'
import { newFlowTemplate, updateFlowTemplate } from '@/service/getData'

export default {
  name: 'new-flow-template',
  props: {
    model: null,
  },
  data() {
    return {
      targetStep: 0,
      flowTemplate: {
        name: null,
        desc: null,
      },
    }
  },
  watch: {
    model(newv) {
      if (newv) {
        this.flowTemplate.name = newv.name
        this.flowTemplate.desc = newv.desc
      }
    },
  },
  mounted() {
    $('#FlowTemplateEditor').on('hidden.bs.modal', this.resetData)
  },
  created() {
    this.initData()
  },
  validations: {
    flowTemplate: {
      name: {
        required,
      },
    },
  },
  methods: {
    initData() {},
    async postFlowTemplate(e) {
      if (this.model) {
        let data = this.flowTemplate
        data.id = this.model.id
        let res = await updateFlowTemplate(data)
        if (res.code == 0) {
          this.$emit('updated', res.data)
        }
        $('#FlowTemplateEditor').modal('hide')
      } else {
        let res = await newFlowTemplate(this.flowTemplate)
        if (res.code == 0) {
          this.$emit('created', res.data)
        }
        $('#FlowTemplateEditor').modal('hide')
      }
    },
    resetData() {
      this.flowTemplate.name = null
      this.flowTemplate.desc = null
    },
  },
}
</script>

<style scoped>
.panel-title {
  font-size: 16px;
}
textarea.form-control {
  height: 66px;
}
.full-panel {
  min-height: 100%;
}

.btn-publish {
  float: right;
  border: 1px solid #fff;
  width: 84px;
  height: 36px;
  margin-right: 10px;
  background-color: #fff;
  color: #294f75;
  font-weight: bold;
  border-radius: 2px;
  font-size: 14px;
}

.btn-publish:hover {
  background-color: #f0f0f0;
}

.flow-fow {
  display: flex;
  justify-content: center;
  height: 50px;
  align-items: center;
}

.flow-start {
  width: 160px;
  height: 50px;
  border-radius: 5px;
  border: 1px solid #ccc;
  text-align: center;
  line-height: 50px;
}

.panel-control {
  float: left;
}

.panel-control .nav-tabs {
  margin: 0 auto;
}
.panel-control .nav-tabs li a {
  font-size: 14px;
}

.base-form .form-control {
  width: 400px;
}

#NewNodeBase,
#NewNodeForm {
  height: 400px;
  overflow: scroll;
}
</style>
